import VueI18n from 'vue-i18n'
import en from "../lang/en";
import nl from "../lang/nl";
import de from "../lang/de";
import es from "../lang/es";
import fr from "../lang/fr";
import pt from "../lang/pt";
import gr from "../lang/gr";

import AppAccordion from "./components/items/AppAccordion.vue";
import VueNumberInput from '@chenfengyuan/vue-number-input';
import 'vue-popperjs/dist/vue-popper.css';
import 'vue-toast-notification/dist/theme-bootstrap.css';

import CountryFlag from 'vue-country-flag'

import Popper from 'vue-popperjs';

import SvgVue from 'svg-vue';

import Gravatar from 'vue-gravatar';

import Multiselect from 'vue-multiselect'

import vueCountryRegionSelect from 'vue-country-region-select'

import VueToast from 'vue-toast-notification';

import { Carousel, Slide } from 'vue-carousel';

import * as Sentry from "@sentry/vue";


window.Vue = require('vue').default;

Vue.use(vueCountryRegionSelect)
Vue.use(SvgVue);

Vue.use(VueToast, {
    duration: 5000,
    position: 'top'
});
Vue.use(Carousel);
Vue.use(Slide);

Vue.prototype.$urlParams = new URLSearchParams(window.location.search);
Vue.prototype.$baseUrl = window.location.protocol + "//" + window.location.host;
Vue.prototype.$homeUrl = document.documentElement.getAttribute('default_lang') == document.documentElement.lang ? Vue.prototype.$baseUrl : window.location.protocol + "//" + window.location.host + "/" + document.documentElement.lang;

Vue.component(
    'bookingpage',
    require('./components/bookingpage.vue').default
);

Vue.component(
    'bulk_admin_update',
    require('./components/items/BulkAdminUpdate.vue').default
)

Vue.component(
    'bookingpayment',
    require('./components/bookingpayment.vue').default
);

Vue.component(
    'scraper',
    require('./components/scraper.vue').default
)

Vue.component(
    'app_accordion',
    AppAccordion
);
Vue.component(
    'gravatar',
    Gravatar,
)
Vue.component(
    'popper',
    Popper
);

Vue.use(VueNumberInput);
Vue.use(CountryFlag);

Vue.component(
    'multiselect',
    Multiselect
);

Vue.component(
    'add_setup_roomitem',
    require('./components/setup/AddSetupRoomItem.vue').default
)

Vue.component(
    'add_setup_room',
    require('./components/setup/AddSetupRoom.vue').default
)

Vue.component(
    'webhook_subscriptions',
    require('./components/setup/WebhookSubscriptions.vue').default
)

Vue.component(
    'bookingprogress',
    require('./components/vimata/bookingprogress.vue').default
)

Vue.component(
    'images_setup',
    require('./components/setup/ImagesSetup.vue').default
)

Vue.component(
    'channel_connections',
    require('./components/setup/ChannelConnections.vue').default
)


Vue.component(
    'app_dropdown',
    require('./components/items/AppDropdown.vue').default
);

Vue.component(
    'file_input_preview',
    require('./components/items/FilePreviewInput.vue').default
);

Vue.component(
    'html_input',
    require('./components/items/html_input.vue').default
);

Vue.component(
    'vimatanavbar',
    require('./components/vimata/vimataNavBar.vue').default
)

Vue.component(
    'app_modal',
    require('./components/items/Modal.vue').default
);

Vue.component(
    'input_translations',
    require('./components/items/Input_translations.vue').default
);

Vue.component(
    'app_dropdown_content',
    require('./components/items/AppDropdownContent.vue').default
);

Vue.component(
    'image_ordering',
    require('./components/image_ordering.vue').default
);


Vue.component(
    'payment_page',
    require('./components/paymentPage.vue').default
)

Vue.component(
    'roomselection',
    require('./components/roomselection.vue').default
);

Vue.component(
    'hotel_date_picker',
    require('./components/hotel_date_picker.vue').default
);

Vue.component(
    'iframe_map',
    require('./components/iframe_map.vue').default
)

Vue.component(
    'search_select',
    require('./components/items/SearchSelect.vue').default
);

Vue.component(
    'guest_selector',
    require('./components/guest_selector.vue').default
);

Vue.component(
    'LocaleChanger',
    require('./components/LocaleChanger.vue').default
);

Vue.component(
    'room_setup',
    require('./components/room_setup.vue').default
)

Vue.component(
    'user_control',
    require('./components/vimata/user_control.vue').default
)

Vue.component(
    'menu_settings',
    require('./components/vimata/settings.vue').default
)

Vue.component(
    'bookingpageresult',
    require('./components/bookingpageresult.vue').default
)

Vue.component(
    'event_itemsadd',
    require('./components/vimata/eventitemsadd.vue').default
)

Vue.component(
    'event_repeatadd',
    require('./components/vimata/eventrepeatadd.vue').default
)

Vue.component(
    'events_json_paste',
    require('./components/events_json_paste.vue').default
)

const i18n = new VueI18n({
    locale: document.documentElement.lang,
    fallbackLocale: 'en',
    messages: {
        en, nl, de, es, fr, pt, gr
    }
})

Sentry.init({
    Vue,
    dsn: "https://a34e9dbcde904e5ebf9f60b9dfecb54e@o4505193544744960.ingest.sentry.io/4505209539788800",
  
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.7,
});


if (document.getElementById("MarketingNavbarRight")) {
    new Vue({
        el: '#MarketingNavbarRight',
        i18n,
    });
}

if (document.getElementsByClassName("vueEl").length) {
    new Vue({
        el: '.vueEl',
        i18n,
    });
}

if (document.getElementById("vimataapp")) {
    new Vue({
        el: '#vimataapp',
        i18n,
    });
}

if (document.getElementById("vnav")) {
    new Vue({
        el: '#vnav',
        i18n,
    })
}
if (document.getElementById("vaside")) {
    new Vue({
        el: '#vaside',
        i18n,
    })
}

if (document.getElementById('iframeApp')) {
    new Vue({
        el: '#iframeApp',
        i18n
    })
}